import { useEffect, useState } from 'react';
import { Common, color } from '@stockbit/ui';
import { Row, Col } from 'antd';
import Search from './Search';

import { CustomButton, LabelForm, ModalPriceAlert } from './styled';

const { Input, Select, Flex, Text } = Common;
const { Option } = Select;

const ITEM_CLOSE = 'close';

interface ModalAddPriceAlertProps {
  visible: boolean;
  loading: boolean;
  onSubmit: (p1?: any, p2?: any, p3?: any) => void;
  onCancel: (p1?: any, p2?: any, p3?: any) => void;
  formData: {
    stock: string;
    value: string;
    operator: string;
    name: string;
  };
  isEdit: boolean;
  modalKey: any;
  isClickAlertLog: boolean;
}

function ModalAddPriceAlert({
  visible,
  loading,
  onSubmit,
  onCancel,
  formData,
  isEdit,
  modalKey,
  isClickAlertLog,
}: ModalAddPriceAlertProps) {
  const [stock, setStock] = useState('');
  const [value, setValue] = useState('');
  const [operator, setOperator] = useState('');
  const [item] = useState(ITEM_CLOSE); // dr web legacy emang ini di hardcode
  const [name, setName] = useState('');

  const handleSelectedValueStock = (selectedStock) => {
    setStock(selectedStock);
  };

  const handleSelectedOperator = (selectedOperator) => {
    setOperator(selectedOperator);
  };

  const handleInputedValue = (inputedValue) => {
    setValue(inputedValue.target.value);
  };

  const handleInputedName = (inputedName) => {
    setName(inputedName.target.value);
  };

  const valueCharacterCheck = (e) => {
    const isNumber = /^\d|\.$/.test(e.key);
    const notIndoButIHSG = stock.toUpperCase() === 'IHSG';
    const preventCondition = notIndoButIHSG
      ? !(isNumber || e.which === 46)
      : !isNumber;
    if (preventCondition) e.preventDefault();
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const command = JSON.stringify({
      stock,
      value: value.trim(),
      operator,
      item,
    });

    onSubmit(name.trim(), command, isEdit);
  };

  useEffect(() => {
    setStock(formData.stock);
    setOperator(formData.operator);
    setValue(formData.value);
    setName(formData.name);
  }, [formData]);

  const handleOnCancel = () => {
    setStock('');
    setOperator('');
    setValue('');
    setName('');

    onCancel();
  };

  return (
    <ModalPriceAlert
      key={modalKey}
      title={`${isEdit || isClickAlertLog ? 'Edit' : 'Create'} Price Alert`}
      centered
      visible={visible}
      onCancel={handleOnCancel}
    >
      <div>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <LabelForm htmlFor="search">Stockname</LabelForm>
        <Search
          // @ts-ignore
          id="search"
          name="search"
          searchValue={stock}
          handleSelectedValueStock={handleSelectedValueStock}
          isEdit={isEdit}
          isClickAlertLog={isClickAlertLog}
        />
      </div>

      <div>
        <Row>
          <Col span={12}>
            <div className="pa-condition">
              <div>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <LabelForm htmlFor="operator">Condition</LabelForm>
              </div>
              <Select
                id="operator"
                onChange={handleSelectedOperator}
                value={operator}
                disabled={!!isClickAlertLog}
                defaultValue="lte"
                style={{ width: '100%' }}
              >
                <Option value="lte">Lesser than equal</Option>
                <Option value="gte">Greater than equal</Option>
                <Option value="lt">Lesser than</Option>
                <Option value="gt">Greater than</Option>
                <Option value="eq">Equal</Option>
              </Select>
            </div>
          </Col>
          <Col span={12}>
            <div className="pa-value">
              <div>
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <LabelForm htmlFor="value">Value</LabelForm>
              </div>
              <Input
                value={value}
                step="0.01"
                onKeyPress={valueCharacterCheck}
                onChange={handleInputedValue}
                disabled={isClickAlertLog}
              />
            </div>
          </Col>
        </Row>
      </div>

      <div>
        <div className="pa-description">
          <div>
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <LabelForm htmlFor="description">Description</LabelForm>
          </div>
          <Input.TextArea
            id="description"
            style={{ width: '100%' }}
            rows="3"
            placeholder="Add your notes..."
            onChange={handleInputedName}
            value={name}
            disabled={isClickAlertLog}
          />
        </div>
      </div>
      {/* footer */}
      {!isClickAlertLog && (
        <Flex justify="flex-end" mt="15px">
          <CustomButton margin="0 10px" $cancel round onClick={onCancel}>
            <Text size="12px" height="1.5" color="rgba(0, 0, 0, 0.65)">CANCEL</Text>
          </CustomButton>
          <CustomButton
            type="primary"
            padding="7px 15px 8px"
            round
            loading={loading}
            onClick={(e) => handleOnSubmit(e)}
          >
            <Text size="12px" height="1.5" color={color.light} align="center">
              {isEdit ? 'SAVE' : 'CREATE'}
            </Text>
          </CustomButton>
        </Flex>
      )}
    </ModalPriceAlert>
  );
}

ModalAddPriceAlert.defaultProps = {
  visible: false,
  loading: false,
  onSubmit: () => {},
  onCancel: () => {},
  formData: {
    stock: '',
    value: '',
    operator: '',
    name: '',
  },
  isEdit: false,
  modalKey: 0,
  isClickAlertLog: false,
};

export default ModalAddPriceAlert;
